export const FALLBACK_IMAGE_ID = 'lh_platzhalter_ohne_abbildung';

/**
 *
 */
async function isImageExists(imgElem: HTMLImageElement, timeout = 5000): Promise<boolean> {
    /*             */
    await new Promise<void>(res => {
        if (imgElem.complete) {
            return res();
        }
        imgElem.onload = () => res();
        imgElem.onerror = () => res();
        setTimeout(() => res(), timeout); /*       */
    });

    /*                         */
    return imgElem.naturalHeight !== 0;
}

/**
 *
 *
 */
export async function removeElementIfContainedImageFailedToLoad(element: Element): Promise<void> {
    const imageElement = element.querySelector('img');
    if (!imageElement) {
        return;
    }

    if (!(await isImageExists(imageElement, 1000))) {
        element.remove();
        return;
    }
}

export function getImageUrl(imageId: string, format?: string): string {
    if (format) {
        return `https:/*                                     */
    }
    return `https:/*                           */
}
